import {apiSlice} from './apiSlice';

/**
 * Endpoints module Chấm điểm SEO.
 *
 * - analyzeSeo: gửi {domain, keyword?, refresh?}. B2 (2026-07-06): BE XẾP HÀNG chấm nền —
 *   trả {id, status:'pending', queued:true}, FE poll getSeoReport(id) tới khi done/failed.
 *   Cache 24h theo (user, domain) vẫn trả THẲNG kết quả đầy đủ (cờ `cached` + `cached_at`,
 *   không queued); refresh=1 ép chấm mới. keyword (tuỳ chọn) bật nhóm On-page theo từ khoá (#3).
 * - getSeoReports / getSeoReport: lịch sử + chi tiết 1 báo cáo.
 * - deleteSeoReport: xoá 1 báo cáo.
 */
export const seoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		analyzeSeo: builder.mutation({
			query: ({domain, keyword = '', refresh = false}) => ({
				url: 'seo/analyze', method: 'post',
				data: {domain, keyword, ...(refresh ? {refresh: 1} : {})},
			}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: ['SeoReport'],
		}),
		getSeoReports: builder.query({
			query: (keyword = '') => ({
				url: 'seo',
				method: 'get',
				...(keyword ? {params: {keyword}} : {}),
			}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['SeoReport'],
		}),
		getSeoReport: builder.query({
			query: (id) => ({url: `seo/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'SeoReport', id}],
		}),
		deleteSeoReport: builder.mutation({
			query: (id) => ({url: `seo/${id}`, method: 'delete'}),
			invalidatesTags: ['SeoReport'],
		}),
	}),
});

export const {
	useAnalyzeSeoMutation,
	useGetSeoReportsQuery,
	useGetSeoReportQuery,
	useDeleteSeoReportMutation,
} = seoApiSlice;
